<template>
  <div class="hc-detail-item" :class="{ 'hc-detail-item--wide': wide }">
    <span class="hc-detail-item__label">
      {{ label }}<span v-if="required" class="hc-detail-item__req" aria-hidden="true">*</span>
    </span>
    <span class="hc-detail-item__value" :class="{ 'hc-detail-item__value--empty': showEmpty }">
      <slot>{{ displayText }}</slot>
    </span>
  </div>
</template>

<script>
export default {
  name: 'ProfileDetailItem',
  props: {
    label: { type: String, required: true },
    value: { default: null },
    required: { type: Boolean, default: false },
    wide: { type: Boolean, default: false },
    emptyText: { type: String, default: 'Not added' },
  },
  computed: {
    normalizedValue() {
      const val = this.value;
      if (val === null || val === undefined || val === '') return '';
      if (Array.isArray(val)) return val.filter(Boolean).join(', ');
      return String(val);
    },
    showEmpty() {
      return !this.$slots.default && !this.normalizedValue;
    },
    displayText() {
      return this.showEmpty ? this.emptyText : this.normalizedValue;
    },
  },
};
</script>
